import $ from 'jquery'

document.addEventListener('DOMContentLoaded', function () {
    const accordions = document.querySelectorAll('.accordion-item');

    accordions.forEach((accordion) => {
        accordion.addEventListener('show.bs.collapse', function (event) {
            event.target.closest('.accordion-item').classList.add('open');
        });

        accordion.addEventListener('hide.bs.collapse', function (event) {
            event.target.closest('.accordion-item').classList.remove('open');
        });
    });
});